import React, { useState } from 'react';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { Form, Field } from 'react-final-form';
import { Button } from '../../../components';
import { post, sendContactEmail } from '../../../util/api';
import css from './ContactForm.module.css';
import ReCapcha from './ReCapcha/ReCapcha';
const capchaSiteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

const ContactForm = () => {
  const [capchaChecked, setCapchaChecked] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const onSubmit = values => {
    const { firstName, lastName, email, message } = values;
    //handle submit values in here
    const requestOptions = {
      recaptchaValue: capchaChecked,
      subject: `${firstName} ${lastName} submitted a contact form`,
      email,
      text: `
            <p>First name: ${firstName}</p>
            <p>Last name: ${lastName}</p>
            <p>Email: ${email}</p>
            <p>Message: ${message}</p>
            `,
    };
    return sendContactEmail(requestOptions)
      .then(resp => {
        setFormSubmitted(true);
      })
      .catch(e => console.log(e));
  };

  const capchaVerified = capchaSiteKey ? capchaChecked : true;

  if (formSubmitted) {
    return (
      <center>
        <h2>
          Thank you for reaching out to us!

          Your message has been received loud and clear. Our team is on it and will get back to you within the next 24 hours. 
          We're excited to discuss your advertising needs and how we can help you reach your goals effectively.
        </h2>
      </center>
    );
  }

  return (
    <div className={css.wrapper}>
      <Form
        onSubmit={onSubmit}
        initialValues={{ stooge: 'larry', employed: false }}
        render={({ handleSubmit, form, submitting, pristine, values }) => {
          const submitDisabled =
            !values.firstName ||
            !values.lastName ||
            !values.email ||
            !values.message ||
            !capchaVerified;
          return (
            <form className={css.formWrapper} onSubmit={handleSubmit}>
              <div className={css.formRow}>
                <label>First Name</label>
                <Field
                  name="firstName"
                  component="input"
                  type="text"
                  label="First Name"
                  placeholder="First Name"
                />
              </div>

              <div className={css.formRow}>
                <label>Last Name</label>
                <Field
                  name="lastName"
                  component="input"
                  type="text"
                  label="Last Name"
                  placeholder="Last Name"
                />
              </div>

              <div className={css.formRow}>
                <label>Email</label>
                <Field
                  name="email"
                  component="input"
                  type="text"
                  label="Email"
                  placeholder="Email"
                />
              </div>

              <div className={css.formRow}>
                <label>Message</label>
                <Field
                  name="message"
                  component="textarea"
                  type="textarea"
                  label="Message"
                  placeholder="Message"
                />
              </div>

              <ReCapcha setCapchaChecked={setCapchaChecked} />

              <div className={css.buttonsWrapper}>
                <Button
                  className={css.actionButton}
                  type="submit"
                  disabled={submitting || pristine || submitDisabled}
                >
                  Submit
                </Button>
                <Button
                  className={css.actionButton}
                  type="button"
                  onClick={form.reset}
                  disabled={submitting || pristine}
                >
                  Reset
                </Button>
              </div>
            </form>
          );
        }}
      />
    </div>
  );
};

export default ContactForm;
